import React from 'react';
import SiteFooter from '../components/footer/SiteFooter';
import SiteHeader from '../components/navigation/SiteHeader';
import SkipLink from '../components/ui/SkipLink';

function NotFoundPage() {
  return (
    <>
      <SkipLink />
      <SiteHeader />
      <main className="page-shell" id="main-content">
        <p className="eyebrow">404</p>
        <h1>Page not found</h1>
        <p>The page may have moved or may not be published.</p>
        <a href="/">Return home</a>
      </main>
      <SiteFooter />
    </>
  );
}

export default NotFoundPage;
